var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7740",
    "data-name": "Group 7740",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.2,
    height: 15.207,
    viewBox: "0 0 15.2 15.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 15.2,
    height: 15.207,
    fill: "#05ce78"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7740-2",
    "data-name": "Group 7740",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M6.511,3.3c0,.4,0,.8,0,1.2A2,2,0,0,1,4.46,6.545q-1.2,0-2.4,0A2,2,0,0,1,0,4.507Q0,3.3,0,2.087A2.006,2.006,0,0,1,2.047.037q1.21-.01,2.42,0A2,2,0,0,1,6.511,2.086c0,.406,0,.813,0,1.219",
    transform: "translate(0 -0.031)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M6.511,187.4c0,.4,0,.8,0,1.2a2.005,2.005,0,0,1-2.043,2.05q-1.21.007-2.42,0A2.008,2.008,0,0,1,0,188.6q-.007-1.21,0-2.421a2,2,0,0,1,2.035-2.038q1.219-.01,2.438,0a2,2,0,0,1,2.034,2.037c0,.406,0,.813,0,1.219",
    transform: "translate(0 -175.445)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M184.068,3.254c0-.43-.009-.86,0-1.29A1.992,1.992,0,0,1,186.041.009q1.272-.018,2.544,0a2,2,0,0,1,1.988,2.014q.007,1.237,0,2.474a2,2,0,0,1-2,2.017q-1.245.01-2.491,0a1.994,1.994,0,0,1-2.011-1.97c-.011-.43,0-.86,0-1.29h0",
    transform: "translate(-175.378 0.001)",
    fill: "#05ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M184.081,187.341c0-.436-.01-.872,0-1.307a1.982,1.982,0,0,1,1.946-1.94q1.307-.023,2.614,0a1.991,1.991,0,0,1,1.941,1.967q.012,1.281,0,2.562a2,2,0,0,1-1.959,1.972q-1.289.016-2.579,0a2,2,0,0,1-1.962-1.929c-.012-.441,0-.883,0-1.325h0",
    transform: "translate(-175.39 -175.394)",
    fill: "#05ce78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.1cd8fc602a30e1f988b1204fc8287da3.svg";
export { ForwardRef as ReactComponent };